import { styled } from 'styles';

export const Container = styled.div`
  background-color: rgba(51, 51, 51, 0.8);
  border-radius: 4px;
  padding: 8px;
`;

export const Item = styled.li`
  line-height: 1;
`;

export const DateValue = styled.span`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.white};
`;

export const Label = styled.span`
  font-size: 1.2rem;
  font-weight: ${({ theme }) => theme.fonts.boldWeight};
`;

export const PriceValue = styled(Label)`
  color: ${({ theme }) => theme.charts.colors.priceLine};
`;

export const VolumeValue = styled(Label)`
  color: #8395ac;
`;
